import { CartRepository } from "../../utils/typescript/repositories/cart.repo.ts";

const clearCartToggles = document.querySelectorAll("[data-clear-cart-trigger]");

clearCartToggles.forEach((toggle) => {
  toggle.addEventListener("click", () =>
    CartRepository.clearCart().subscribe((url) => window.location.replace(url)),
  );
});
